//Users Listing
export const FETCH_USERS_LISTING_FAILURE = 'FETCH_USERS_LISTING_FAILURE';
export const FETCH_USERS_LISTING_SUCCESS = 'FETCH_USERS_LISTING_SUCCESS';

//User Groups Listing
export const FETCH_USERS_GROUP_LISTING_SUCCESS = 'FETCH_USERS_GROUP_LISTING_SUCCESS';
export const FETCH_USERS_GROUP_LISTING_FAILURE = 'FETCH_USERS_GROUP_LISTING_FAILURE';

export const RESET = 'RESET';
